import { get, has, isEmpty } from 'lodash';
import type { AttendeesType } from 'Store/booking/attendees/attendees.selector';
import 'Store/booking/attendees/attendees.selector';
type State = Array<any>;
type TransferUpdateFields = {
  id: string;
  availableTransfers: Array<any>;
  selectedTransfers: Array<any>;
  paymentSchedule: PaymentSchedule;
  price: ProposalPrice | null | undefined;
  attendees: ProposalAttendees;
  attendeesPrice: Array<AttendeePrice>;
  households: Array<AttendeesType>;
};

function getTransportsWithTransfer(proposal: Proposal): Transport {
  return {
    ...proposal.transports,
    inbound: { ...get(proposal, 'transports.inbound'), transferIncluded: true },
    outbound: { ...get(proposal, 'transports.outbound'), transferIncluded: true },
  };
}

function setTransferIncludedInProposal(proposal: Proposal): Proposal {
  return {
    ...proposal,
    ...(has(proposal, 'transports.inbound') && has(proposal, 'transports.outbound')
      ? {
          transports: getTransportsWithTransfer(proposal),
        }
      : null),
  };
}

function updateProposal(
  proposalId: string,
  state: State,
  updateFn: (arg0: Proposal) => Proposal,
): State {
  const indexToUpdate = state.findIndex((p) => get(p, 'id') === proposalId);
  return indexToUpdate !== -1
    ? state.map((proposal, index) => (index === indexToUpdate ? updateFn(proposal) : proposal))
    : state;
}

function updateTransfers(state: State, proposalFields: Array<TransferUpdateFields>): State {
  if (isEmpty(proposalFields)) {
    return state;
  }

  const updateFn = (proposal) => {
    const currentProposal =
      proposalFields.find(({ id }) => id === get(proposal, 'id')) ?? ({} as TransferUpdateFields);
    const { price, availableTransfers, paymentSchedule, selectedTransfers } = currentProposal;
    return {
      ...proposal,
      price: { ...proposal.price, ...price },
      paymentSchedule,
      availableTransfers: availableTransfers || proposal.availableTransfers,
      selectedTransfers: selectedTransfers || proposal.selectedTransfers,
    };
  };

  return state.map(updateFn);
}

function updateTransportError(state: State, proposalId: string, error: HTTPError): State {
  const updateFn = (proposal) => ({ ...proposal, transports: { ...proposal.transports, error } });

  return updateProposal(proposalId, state, updateFn);
}

function updateAttendees(state: State, proposalFields: TransferUpdateFields): State {
  if (!proposalFields) {
    return state;
  }

  const { price, attendees, attendeesPrice, households } = proposalFields;

  const updateFn = (proposal) => ({
    ...proposal,
    price,
    attendees: { ...proposal.attendees, list: attendees.list },
    households,
    attendeesPrice,
  });

  return updateProposal(proposalFields.id, state, updateFn);
}

export {
  setTransferIncludedInProposal,
  updateProposal,
  updateAttendees,
  updateTransfers,
  updateTransportError,
};
